export const GET_TYPE_ALERT = 'GET_TYPE_ALERT'
export const GET_TYPE_ALERT_EXITO = 'GET_TYPE_ALERT_EXITO'
export const GET_TYPE_ALERT_ERRROR = 'GET_TYPE_ALERT_ERROR'
